import { render } from "./IndexHome.vue?vue&type=template&id=48a2ba74&scoped=true"
import script from "./IndexHome.vue?vue&type=script&lang=js"
export * from "./IndexHome.vue?vue&type=script&lang=js"

import "./IndexHome.vue?vue&type=style&index=0&id=48a2ba74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a2ba74"]])

export default __exports__